import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { DownloadIcon, CalendarCheckIcon, TrendingUpIcon } from 'lucide-react';
export function HowItWorksSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const steps = [{
    icon: DownloadIcon,
    number: '1',
    title: 'Descarga ZIP, imprime/abre Canva',
    description: 'Recibe acceso instantáneo a todos los templates en formato PDF y editable en Canva'
  }, {
    icon: CalendarCheckIcon,
    number: '2',
    title: 'Marca Template 1 diario + síntomas específicos',
    description: 'Solo 2 minutos cada día para trackear calorones, sueño, humor y remedios'
  }, {
    icon: TrendingUpIcon,
    number: '3',
    title: 'Domingo revisa Resumen —ajusta remedios',
    description: 'Ve tus patrones, identifica triggers, ajusta tu rutina basada en TU data'
  }];
  return <section ref={ref} className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-188">
      <div className="max-w-6xl mx-auto" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-190">
          <h2 className="text-purple-deep text-4xl sm:text-5xl md:text-6xl font-bold font-heading mb-6" data-id="element-191">
            Cómo funciona:
          </h2>
          <p className="text-gray-700 text-xl sm:text-2xl" data-id="element-192">
            Simple, rápido, efectivo
          </p>
        </motion.div>

        <div className="space-y-8 mb-16" data-id="element-193">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative" data-id="element-194">
              <div className="flex flex-col sm:flex-row items-start gap-6 bg-gradient-to-br from-purple-50 to-lavender-light/30 rounded-2xl p-8 shadow-lg" data-id="element-195">
                <div className="flex-shrink-0 w-20 h-20 rounded-full bg-purple-main flex items-center justify-center shadow-lg" data-id="element-196">
                  <step.icon className="w-10 h-10 text-white" data-id="element-197" />
                </div>
                <div className="flex-1" data-id="element-198">
                  <div className="flex items-center gap-3 mb-3" data-id="element-199">
                    <span className="text-purple-main text-2xl font-bold font-heading" data-id="element-200">
                      Paso {step.number}
                    </span>
                  </div>
                  <h3 className="text-purple-deep text-2xl sm:text-3xl font-bold font-heading mb-3" data-id="element-201">
                    {step.title}
                  </h3>
                  <p className="text-gray-700 text-lg leading-relaxed" data-id="element-202">
                    {step.description}
                  </p>
                </div>
              </div>
              {index < steps.length - 1 && <div className="hidden sm:block absolute left-10 top-full h-8 w-0.5 bg-gradient-to-b from-purple-main to-transparent" data-id="element-203" />}
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="bg-gradient-to-r from-sage/20 to-sage/10 rounded-3xl p-8 sm:p-12 border-2 border-sage/30" data-id="element-204">
          <p className="text-purple-deep text-2xl sm:text-3xl font-bold font-heading text-center mb-4" data-id="element-205">
            En 7 días:
          </p>
          <p className="text-gray-800 text-xl sm:text-2xl leading-relaxed text-center" data-id="element-206">
            María (47, LA) identificó{' '}
            <span className="font-bold text-coral" data-id="element-207">
              "cena picante = 3 calorones"
            </span>
            . Cambió —duerme seco.
          </p>
        </motion.div>
      </div>
    </section>;
}